import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'components/ui/tables';
import { ProgressCell } from './progress-cell';
import { VocabCountCell } from './vocab-count-cell';
import { StudentNameCell } from '../table-cells/student-name-cell';
import { StudentEmailCell } from '../table-cells/student-email-cell';
import { StudentTimeStudiedCell } from '../table-cells/student-time-studied-cell';
import { Text } from 'naan/primitives/text';
import { useCurrentAssignment } from './current-assignment-context';
import { StudentProgress } from 'core/models/user-manager';

import __ from 'core/lib/localization';
import { bugsnagNotify } from '@app/notification-service';

export const AssignmentStudentSection = observer(
  ({ show }: { show: boolean }) => {
    const { assignment } = useCurrentAssignment();
    const studentProgresses = assignment.studentProgresses;
    // const { students } = classroom;
    const { story } = assignment;
    // console.log({ classroom, assignment });

    React.useEffect(() => {
      assignment?.refreshStudentProgresses().catch(bugsnagNotify);
    }, [assignment]);

    if (!show) {
      return null;
    }

    // const loadingData = data === null || store.loadingData;
    // const tableData = data?.studentProgresses ?? [];

    return (
      <>
        {/* // todo: confirm if studentProgresses is guarantees to include all students */}
        {studentProgresses.length > 0 ? (
          <Table
            data={studentProgresses}
            cells={[
              {
                headerLabel: __('Name', 'name'),
                renderCell: ({ name }: StudentProgress) => {
                  return <StudentNameCell name={name} />;
                },
              },
              {
                headerLabel: __('Email', 'email'),
                renderCell: ({ email }: StudentProgress) => {
                  return <StudentEmailCell email={email} />;
                },
              },
              {
                headerLabel: __('Progress', 'progress'),
                renderCell: (progress: StudentProgress) => (
                  <ProgressCell {...{ story, progress }} />
                ),
              },
              {
                headerLabel: __('Time studied', 'timeStudied'),
                renderCell: ({ allTimeStudiedHourMin }: StudentProgress) => {
                  return (
                    <StudentTimeStudiedCell
                      allTimeStudiedHourMin={allTimeStudiedHourMin}
                    />
                  );
                },
              },
              {
                headerLabel: __('Vocab', 'vocab'),
                renderCell: ({ vocabCount }: StudentProgress) => {
                  return <VocabCountCell vocabCount={vocabCount} />;
                },
              },
            ]}
          />
        ) : (
          <Text>
            {__(
              'After you add students to this class you will see their progress for this story here',
              'studentsZeroState'
            )}
          </Text>
        )}
      </>
    );
  }
);
